<template>
  <div class="text-right">
    <Menu @click="toggleMenu"  as="div" class="relative inline-block text-left w-full">
      <MenuButton class="inline-flex justify-center rounded-sm bg-black bg-opacity-20 px-3 sm:px-4 py-2.5 font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
        <div v-if="menuOpen" class="mr-1 sm:mr-2"><font-awesome-icon icon="fa-solid fa-angle-up" /></div>
        <div v-else class="mr-1 sm:mr-2"><font-awesome-icon icon="fa-solid fa-angle-down" /></div>
        {{ label }}
      </MenuButton>
      <transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in" leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
        <MenuItems :class="[fullWidthMobile ? 'fixed left-0 right-0 sm:absolute sm:left-auto sm:right-0 w-full sm:w-56' : 'absolute right-0 w-56', 'mt-2 origin-top-right divide-y divide-gray-100 rounded-sm bg-gray-100 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none max-h-96 overflow-y-auto z-50']">
          <div class="px-1">
            <MenuItem as="div" class="my-1" v-for="item in items" :key="getItemValue(item)" v-slot="{ active }">
              <button
                v-if="getItemValue(item) == label"
                @click="selectItem(item)"
                class="bg-gray-700 text-white group flex w-full items-center rounded-sm p-2 text-xs"
              >
                <font-awesome-icon
                  v-if="showStatusIcons && item.status"
                  :icon="item.status === 'complete' ? 'fa-circle-check' : 'fa-circle-xmark'"
                  :class="item.status === 'complete' ? 'text-green-400' : 'text-red-400'"
                  class="mr-2"
                />
                {{ getItemValue(item) }}
              </button>
              <button
                v-else
                @click="selectItem(item)"
                :class="[active ? 'bg-gray-700 text-white' : 'text-gray-900', 'group flex w-full items-center rounded-sm p-2 text-xs']"
              >
                <font-awesome-icon
                  v-if="showStatusIcons && item.status"
                  :icon="item.status === 'complete' ? 'fa-circle-check' : 'fa-circle-xmark'"
                  :class="item.status === 'complete' ? 'text-green-500' : 'text-red-500'"
                  class="mr-2"
                />
                {{ getItemValue(item) }}
              </button>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'

export default {
  name: "DropDown",
  components: {Menu, MenuButton, MenuItems, MenuItem},
  props: {
    label: String,
    items: Array,
    showStatusIcons: {
      type: Boolean,
      default: false
    },
    fullWidthMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    selectItem: function(item) {
      // Emit the value (string) for backward compatibility
      this.$emit("valueSelected", this.getItemValue(item));
    },
    toggleMenu: function() {
      this.menuOpen = !this.menuOpen
    },
    getItemValue: function(item) {
      // Support both string items and object items with {value, status}
      return typeof item === 'string' ? item : item.value;
    }
  }
}
</script>